



























import { AutoLoadComplete, AutoLoadContext, AutoLoadError } from '@/components/organisms/auto-load/model'
import {
  AutoLoadByFkuIds,
  AutoLoadStrategy,
  AutoLoadWithQuery,
} from '@ajax/vue/components/templates/item-list/paging/strategy/auto-load-strategy'
import { Either } from 'fp-ts/lib/Either'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AppId from '@/util/appid'
import { BrandRouteResolver } from '@/util/brandRouteResolver'

import ItemListAutoLoadable from '@/components/organisms/item-list/AutoLoadable.vue'
import { ListWithPagination } from '@/models/api/response/list'
import { ItemKind } from '@/models/item/kind'
import ItemService from '@/services/api/productclass'
import SelectThumbnailImageBuilder from '@/services/product-image/select-thumbnail-image-builder'

import { log } from '@/log'
import ItemListHeaderAddonBuilder from './item-list/ItemListHeaderAddonBuilder'
import { withoutPagingQuery } from './item-list/paging/query'

@Component({
  components: {
    ItemListAutoLoadable,
  },
})
/**
 * MPAの商品一覧画面 or フリーコンテンツの商品リストから使用される商品一覧表示コンポーネント
 */
class Itemlist extends Vue {

  @Prop({ default: () => ({}) })
  query: { [key: string]: any }

  @Prop({ required: true })
  displayType: string

  @Prop({ default: 24 })
  defaultCount: number

  @Prop({ default: false })
  instaview: boolean

  @Prop({ default: 3 })
  column: number

  @Prop({ default: false })
  instapage: boolean

  @Prop({ default: false })
  dynamicMode: boolean

  @Prop({ default: false })
  counterMode: boolean

  @Prop({ default: 'default' })
  itemKind: ItemKind

  @Prop({ default: false })
  autoLoadEnabled: boolean

  @Prop({ default: null })
  displayLevelOfImageToDisplay: number | null

  @Prop({ default: null })
  ids: null | {
    /** 指定ID全体 */
    all: string[]
    /** サーバーで取得・描画済みのID */
    loadedOnServer: string[],
    /** clientでオートロードする予定のID */
    loadOnClient: string[]
  }

  hasItems: boolean = true

  rootEl: Element | null = null

  mounted() {
    this.rootEl = this.$el
  }

  get basePage(): number {
    const ajaxBasePage = 1

    return ajaxBasePage
  }

  get appId(): string {
    return AppId.getByBrandName(
      BrandRouteResolver.resolveBrandFromPathElement(this.$route.params.brand_english_name)
    )
  }

  get itemService(): ItemService {
    return new ItemService(this.appId)
  }

  get itemListHeaderAddon(): typeof Vue | null {
    return ItemListHeaderAddonBuilder.create(this.itemKind, this.displayLevelOfImageToDisplay).build()
  }

  get showItemListHeaderAddon(): boolean {
    // 商品が0件のときは HeaderAddon を表示する意味がないため、呼び出し側で除外する
    return this.itemListHeaderAddon !== null && this.hasItems
  }

  get selectThumbnailImageBuilder(): SelectThumbnailImageBuilder {
    if (this.itemKind !== 'contact-lens') {
      return SelectThumbnailImageBuilder.createForApparel(this.instapage)
    }

    // displayLevelOfImageToDisplay が指定されている場合はそちらが優先され、 imageAppKind は無視される
    // またその場合は ItemListHeaderAddon も非表示になる（ ItemListHeaderAddonBuilder 参照）
    return SelectThumbnailImageBuilder.createForContactLens(
      this.instapage,
      this.displayLevelOfImageToDisplay,
      this.$store.getters['contactLensImageType/imageAppKind']
    )
  }

  fetchItemList(baseQuery: object, context: AutoLoadContext): Promise<Either<Error, ListWithPagination<any>>> {
    return this.pagingStrategy.fetchPage(
      {
        ...baseQuery,
        ...withoutPagingQuery(this.query),
      },
      context
    )
  }

  private get pagingStrategy(): AutoLoadStrategy<any> {
    return this.ids === null
      ? new AutoLoadWithQuery({
        productclassService: this.itemService,
      })
      : new AutoLoadByFkuIds({
        ids: this.ids,
        productclassService: this.itemService,
        countPerPage: this.defaultCount,
      })
  }

  onComplete(result: AutoLoadComplete) {
    this.hasItems = result.pagination !== null && result.pagination.total > 0
  }

  onError(error: AutoLoadError) {
    log.error(error)
  }
}

export default Itemlist
